import api from '@/utils/api';
import {
    GET_ALL_FEEDBACK_REQUEST,
    GET_SPECIFIC_FEEDBACK_REQUEST,
    UPDATE_SPECIFIC_FEEDBACK_REQUEST,
    CREATE_NEW_FEEDBACK_REQUEST,
    REMOVE_FEEDBACK_REQUEST
} from './types';
import { NotificationManager } from 'react-notifications';

export const fetchFeedbackRequestList = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/feedback-requests', { params: filter }).then(res => {
            dispatch({ type: GET_ALL_FEEDBACK_REQUEST, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createFeedbackRequest = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/feedback-requests', data).then(res => {
            dispatch({ type: CREATE_NEW_FEEDBACK_REQUEST, payload: res.data.data });
            NotificationManager.success("Thêm mới yêu cầu thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const fetchFeedbackRequestDetail = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/feedback-requests/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_FEEDBACK_REQUEST, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const updateFeedbackRequest = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/feedback-requests/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_FEEDBACK_REQUEST, payload: res.data.data });
            NotificationManager.success("Cập nhật yêu cầu thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeFeedbackRequest = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/feedback-requests`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_FEEDBACK_REQUEST, payload: ids });
            NotificationManager.success("Xoá yêu cầu thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
